import Hardware from 'eflex/models/hardware';
import { attr } from '@ember-data/model';
import { service } from '@ember/service';
import { isPresent } from '@ember/utils';
import { validator, buildValidations } from '@eflexsystems/ember-tracked-validations';

@buildValidations({
  name: [validator('presence', true)],
  cameraName: [validator('presence', true)],
  cameraId: [validator('presence', true)],
})
class WebCam extends Hardware {
  @attr('string') cameraId;
  @attr('string') cameraName;

  @service webCam;
  @service intl;

  get isWebCam() {
    return true;
  }

  get isConfigured() {
    return isPresent(this.cameraId);
  }

  get isConnected() {
    return true;
  }

  get hardwareGroup() {
    return this.intl.t('webCam');
  }
}

export default WebCam;
